var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrolley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C48900",
    d: "M12.247 3.446v2.585a19.556 19.556 0 011.917.01l.649-2.595h.855v2.732c2.061.264 3.421.75 3.421.75v3.36h.856v2.566l-.856.855v5.987h-.855a.856.856 0 01-.855-.855H8.826a.856.856 0 01-.855.855h-.855v-5.987l-.856-.855v-2.566h.855v-3.36s1.44-.514 3.599-.772l.678-2.71h.855zM9.681 15.42a.856.856 0 000 1.71l.1-.006a.856.856 0 00-.1-1.704zm6.842 0a.856.856 0 000 1.71l.1-.006a.856.856 0 00-.1-1.704zm.856-5.987H8.826v3.42c0 .473.383.856.855.856h6.842a.856.856 0 00.856-.855V9.433z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolley);
export default __webpack_public_path__ + "static/media/trolley.32482dcd29fb07b9b51cf9d1cb729f9c.svg";
export { ForwardRef as ReactComponent };